import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Evict any legacy caching service worker from an older build. We register the kill-switch SW
// ONLY when a registration already exists, so a browser that never had a SW does nothing (and
// after the kill-switch unregisters itself there is no registration left -> it never re-registers,
// avoiding a reload loop). Browsers still holding the old SW also get the kill-switch via the
// browser's own SW update-check, which wipes caches, unregisters and reloads with fresh assets.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .getRegistrations()
      .then((regs) => {
        if (regs.length > 0) {
          navigator.serviceWorker.register("/service-worker.js").catch(() => {});
        }
      })
      .catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
